(function () {
  'use strict';

  let angular = window.angular;

  PublicRouter.$inject = ['$stateProvider'];

  angular.module('app').config(PublicRouter);

  function PublicRouter($stateProvider, utils) {
    $stateProvider
      .state('member', {
        url: '/member?style&access_token&user_id&embedded',
        redirectTo: 'member.home',
        authenticated: true,
        component: 'memberComponent',
        params: {
          style: { type: 'string', inherit: true },
          access_token: { type: 'string', inherit: true },
          user_id: { type: 'string', inherit: true },
          embedded: { type: 'string', inherit: true },
        },
        resolve: {
          user: [
            'UserService',
            'AppUtils',
            '$rootScope',
            function (UserService, utils, $root) {
              return UserService.getCurrent()
                .then((current) => {
                  return UserService.findById(current.id);
                })
                .then((user) => {
                  user.isAdmin = true;
                  user.isSuperAdmin = true;
                  user.image = UserService.getUserImageUrl(user);
                  $root.user = user;

                  if (user.mustChangePassword) {
                    const redirectError = new Error('Password change required');
                    redirectError.redirectTo = 'forcePasswordChange';
                    throw redirectError;
                  }

                  return user;
                })
                .catch((err) => {
                  if (err && err.redirectTo) {
                    throw err;
                  }
                  throw utils.getHTTPError(err, { redirectTo: 'public.login' });
                });
            },
          ],
          isAdmin: () => true,
          isSuperAdmin: () => true,
          vars: [
            'Var',
            function (Var) {
              return Var.find({ filter: { order: 'name ASC' } }).$promise.then((vars) => {
                return vars;
              });
            },
          ],
        },
        ncyBreadcrumb: {
          label: '<i class="fas fa-home"></i>',
        },
      })
      .state('forcePasswordChange', {
        url: '/password-change',
        authenticated: true,
        component: 'forcePasswordChangePage',
      })
      .state('member.home', {
        url: '/home',
        authenticated: true,
        component: 'memberHome',
        redirectTo: 'member.home.vars',

        ncyBreadcrumb: {
          label: 'Home',
        },
      })
      .state('member.home.vars', {
        url: '/vars',
        authenticated: true,
        component: 'memberHomeVars',
        ncyBreadcrumb: {
          label: 'Resellers',
        },
      })
      .state('member.home.configs', {
        url: '/global-users',
        component: 'globalConfigs',
        requireADLogin: true,
        authenticated: true,
        ncyBreadcrumb: {
          label: '{{"entities.organization.organizationConfig.modelNamePl" | translate}}',
        },
        resolve: {
          vars: [
            'Var',
            function (Var) {
              return Var.find({ filter: { order: 'name ASC' } }).$promise.then((vars) => {
                return vars;
              });
            },
          ],
          superAdmins: [
            'SuperAdmin',
            function (SuperAdmin) {
              return SuperAdmin.find({ filter: { order: 'name ASC' } }).$promise.then(
                (superAdmins) => {
                  return superAdmins;
                }
              );
            },
          ],
          supportAdmins: [
            'SupportAdmin',
            function (SupportAdmin) {
              return SupportAdmin.find({
                filter: {
                  order: 'name ASC',
                  include: [
                    {
                      relation: 'vars',
                    },
                  ],
                },
              }).$promise;
            },
          ],
        },
      });
  }
})();
